export default {
  setAtivo(state, payload) {
    state.ativo = payload;
  },
  setProduto(state, payload) {
    state.produto = payload;
  },
  setItens(state, payload) {
    state.itens = payload;
  },
  setParcelas(state, payload) {
    state.parcelas = payload;
  },
  setCalcFormParcelas(state, payload) {
    state.form.parcelas = [];
    let { qtd, par } = payload;
    let resto = 0;
    if (qtd % par != 0) {
      resto = qtd % par;
      qtd = qtd - resto;
    }
    for (let i = 0; i < par; i++) {
      state.form.parcelas[i] = qtd / par + resto;
      resto = 0;
    }
  },
  setAllFormParcelas(state, payload) {
    state.form.parcelas = payload;
  },
  setForm(state, payload) {
    state.form.parcelas[payload.index] = parseFloat(payload.value);
    if (payload.tempo) state.form.tempo = parseFloat(payload.tempo);
    if (payload.diautil) state.form.diautil = parseFloat(payload.diautil);
    if (payload.qtde) state.form.qtde = parseFloat(payload.qtde);
  },
  setFormParcela(state, payload) {
    state.form.parcela = payload;
  },
  setCalcular(state, payload) {
    state.itens.push(payload);
  },
  setParcela(state, payload) {
    state.parcelas.push(payload);
  }
};
